<template>
  <div>
    <b-modal id="modalPeriodicService" ref="modalPeriodicService" :title="$t('Periodic service')" hide-footer size="lg">
      <div v-if="editItem  && (serviceType === 2)" >
        <b-tabs pills card>
          <b-tab :title="$t('Main')">
            <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
              <b-form-input type="text" disabled v-model="editItem.parent_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_name" aria-describedby="inputFeedbackName" :state="editItem.service_name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="suppliertList" v-model="editItem.invoice_sup_id"/>
            </b-form-group>
            <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
              <b-form-checkbox v-model="editItem.link_by_default" value=1 unchecked-value=0>{{ $t('Attach by default') }}</b-form-checkbox>
              <b-form-checkbox v-model="editItem.multiple_linking" value=1 unchecked-value=0>{{ $t('Allow multiple linking') }}</b-form-checkbox>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Service parameters')">
            <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" :disabled="editItem.links_count !== 0" v-model="editItem.cost" aria-describedby="inputFeedbackCost" :state="editItem.cost !== ''"/>
              <b-form-invalid-feedback id="inputFeedbackCost">
                {{ $t('Enter cost') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="chargeMethodList" v-model="editItem.charge_method"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="policyList" v-model="editItem.policy_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="schemeList" v-model="editItem.scheme_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="contractList" v-model="editItem.contract_type"/>
            </b-form-group>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="savePeriodicService" @cancel="$refs.modalPeriodicService.hide" size="lg"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    serviceType: null,
    schemeList: null,
    policyList: null,
    suppliertList: null,
    contractList: null,
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    editItem: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      chargeMethodList: [
        {text: this.$i18n.t('At the start of the period'), value: 1},
        {text: this.$i18n.t('At the end of the period'), value: 2},
        {text: this.$i18n.t('Flow method'), value: 3}
      ]
    }
  },
  methods: {
    updEditItem (item) {
      this.editItem = JSON.parse(JSON.stringify(item))
    },
    async savePeriodicService () {
      if (!this.editItem.service_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.editItem.parent_id === 0) this.editItem.parent_id = -1
        this.editItem.link_by_default = Number(this.editItem.link_by_default)
        this.editItem.multiple_linking = Number(this.editItem.multiple_linking)
      }
      if (this.isTariffPlan) {
        this.editItem.tariff_id = this.currentRowTariffPlans.id
      }
      this.editItem.cost = Number(this.editItem.cost)
      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_PERIODIC_SERVICE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_PERIODIC_SERVICE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$refs.modalPeriodicService.hide()
          this.$root.$emit('makeToasts')

          let sid = this.isEdit ? this.editItem.service_id : response.data.service_id

          let invID = this.editItem.invoice_sup_id ? this.editItem.invoice_sup_id : 0
          this.$store.dispatch('Tariffing/UPDATE_SUPPLIER_ID', {service_id: sid, invoice_sup_id: invID})

          this.$store.dispatch('Tariffing/UPDATE_CHARGE_POLICY', {service_id: sid, policy_id: this.editItem.policy_id})

          if (this.isTemplates || this.isTariffPlan) {
            let ml = this.editItem.multiple_linking ? this.editItem.multiple_linking : 0
            this.$store.dispatch('Tariffing/UPDATE_MULTI_LINKING', {service_id: sid, multiple_linking: ml})
          }
        }
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formPeriodicService.vue